import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { CertificationTableFilterSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/certification/_list/')({
  validateSearch: zodValidator(CertificationTableFilterSchema)
});